/**
 * OwnerPayoutCard — Task 4.2
 * Renders pending payouts for one centre in the owner dashboard.
 * READ-ONLY — no approve button anywhere on this component.
 * Approval is centreAdmin's responsibility (ADR-007 + financial constraint).
 */

import React, { useState } from 'react';

const BRAND_GREEN = '#4a8f82';

function fmt(date) {
  if (!date) return '—';
  return new Date(date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

function fmtAmount(n) {
  return `₹${Number(n).toLocaleString('en-IN')}`;
}

export default function OwnerPayoutCard({ centre }) {
  const [open, setOpen] = useState(true);
  const { tenantName, city, payouts } = centre;

  return (
    <div style={s.card}>
      <button style={s.header} onClick={() => setOpen(o => !o)}>
        <div style={s.headerLeft}>
          <span style={s.centreName}>{tenantName}</span>
          {city && <span style={s.city}>{city}</span>}
          <span style={s.badge}>{payouts.length} pending</span>
        </div>
        <span style={s.chevron}>{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div style={s.list}>
          {payouts.map((p) => (
            <div key={p._id} style={s.row}>
              <div style={s.healerCol}>
                <div style={s.healerName}>
                  {p.healerId?.firstName || '—'} {p.healerId?.lastName || ''}
                </div>
                <div style={s.weekLabel}>Week ending {fmt(p.weekEnding)}</div>
              </div>
              <div style={s.amountCol}>{fmtAmount(p.totalAmount)}</div>
              <div style={s.statusBadge}>Pending</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  card: {
    background:   '#fff',
    border:       '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow:     'hidden',
    marginBottom: '12px'
  },
  header: {
    width:          '100%',
    background:     'none',
    border:         'none',
    padding:        '16px 20px',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'space-between',
    cursor:         'pointer',
    minHeight:      '44px'
  },
  headerLeft: { display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' },
  centreName: {
    fontFamily: "'Raleway', sans-serif",
    fontWeight: '700',
    fontSize:   '14px',
    color:      '#1a1a2e'
  },
  city:       { fontSize: '12px', color: '#888' },
  badge: {
    background:   '#fef3e2',
    color:        '#d97706',
    fontFamily:   "'Raleway', sans-serif",
    fontWeight:   '700',
    fontSize:     '11px',
    padding:      '3px 10px',
    borderRadius: '20px'
  },
  chevron:    { fontSize: '12px', color: '#999' },
  list:       { borderTop: '1px solid #f0f0f0' },
  row: {
    display:       'flex',
    alignItems:    'center',
    padding:       '12px 20px',
    borderBottom:  '1px solid #f5f5f5',
    gap:           '12px'
  },
  healerCol:  { flex: 1 },
  healerName: {
    fontFamily: "'Raleway', sans-serif",
    fontWeight: '700',
    fontSize:   '13px',
    color:      '#1a1a2e'
  },
  weekLabel:  { fontSize: '11px', color: '#888', marginTop: '2px' },
  amountCol: {
    fontFamily: "'Raleway', sans-serif",
    fontWeight: '700',
    fontSize:   '15px',
    color:      BRAND_GREEN,
    minWidth:   '80px',
    textAlign:  'right'
  },
  statusBadge: {
    fontSize:     '10px',
    fontWeight:   '700',
    fontFamily:   "'Raleway', sans-serif",
    textTransform:'uppercase',
    letterSpacing:'1px',
    color:        '#d97706',
    background:   '#fef3e2',
    padding:      '4px 10px',
    borderRadius: '20px',
    whiteSpace:   'nowrap'
  }
};
